import { defaultStyles, FileIcon as FileIconComponent } from 'react-file-icon';

import { cn } from '@/shadcn/lib/utils';

import { getFileExtension } from '@/components/fileIcon/file.utils';

type Props = {
  name: string;
  className?: string;
};
export const FileIcon = ({ name, className }: Props) => {
  const fileExtension = getFileExtension(name);
  return (
    <div className={cn('shrink-0', className)}>
      <FileIconComponent
        extension={fileExtension}
        {...defaultStyles[fileExtension]}
      />
    </div>
  );
};
